import { ChangeDetectionStrategy, Component, inject, Type } from '@angular/core';
import { TimezoneAbbreviationPipe } from '@groundworks/ngx-groundworks-ui';
import { AlertProject } from '../../../sdk/sdk';
import { AlertPopoverService } from './alert-popover.service';

@Component({
  selector: 'app-alert-popover',
  imports: [TimezoneAbbreviationPipe],
  template: `
    <ul class="list-unstyled mb-0">
      @for (project of projects(); track $index) {
        <li class="mb-1">
          <a [href]="buildHref(project)" target="_blank" rel="noopener">
            <span class="text-truncate mw-2">{{ project.customerLastName }}</span> &nbsp; {{ project.type }} &nbsp; Begins: {{ project.startDate | timezoneAbbreviation:'MM/dd/yyyy':'UTC' }}
          </a>
        </li>
      }
    </ul>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertPopoverComponent {
  protected readonly alertPopoverService = inject(AlertPopoverService);
  protected readonly alertType: string = '';

  projects = this.alertPopoverService.projectsForType(this.alertType);

  buildHref(project: AlertProject): string {
    return `/viewer?opportunityId=${project.opportunityId}`;
  }
}

/**
 * Creates a unique AlertPopoverComponent subclass bound to a specific alert type.
 * Each subclass reads only its own type's projects from the shared service.
 * This avoids DOM scraping or timing issues with the library's popover lifecycle.
 */
export function createAlertPopoverComponent(alertType: string): Type<AlertPopoverComponent> {
  @Component({
    selector: 'app-alert-popover',
    imports: [TimezoneAbbreviationPipe],
    template: `
      <ul class="list-unstyled mb-0">
        @for (project of projects(); track $index) {
          <li>
            <a [href]="buildHref(project)" target="_blank" rel="noopener">
              <span class="text-truncate mw-2">{{ project.customerLastName }}</span> &nbsp; {{ project.type }} &nbsp; Begins: {{ project.startDate | timezoneAbbreviation:'MM/dd/yyyy':'UTC' }}
            </a>
          </li>
        }
      </ul>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
  class TypedAlertPopoverComponent extends AlertPopoverComponent {
    override readonly alertType = alertType;
    override projects = this.alertPopoverService.projectsForType(alertType);
  }

  return TypedAlertPopoverComponent;
}
